String.prototype.replaceAll = function(search, replacement) {
    let target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};


// WEBPACK FOOTER //
// ./src/js/utilities/prototypes.js